export default "__VITE_ASSET__49b202e8__"